module.exports={name:"第2章 不死身の傭兵",number:2};